




























import { Result } from '@empathybroker/tsclient-search';

import { ScoreCriteriaDetailTypeEnum } from '../../enums';

import { SteppedAnimationMixin } from '../../mixins';

import { ExplainUtils } from '../../utils';

import TransitionHeight from '../transition-height.component.vue';
import ExplainResultsHeaderRow from './explain-results-header-row.component.vue';
import ExplainResultsScoreRow from './explain-results-score-row.component.vue';
import ExplainResultsTiebreakersRow from './explain-results-tiebreakers-row.component.vue';

export default {
  name: 'explain-results-table',
  props: {
    results: {
      type: Array,
      required: true
    },
    defaultCriteriaDetailTypes: {
      type: Array,
      default: () => []
    },
    initialAnimationDurationInMillis: {
      type: Number,
      default: 0
    },
    messages: {
      type: Object,
      required: true
    }
  },
  mixins: [SteppedAnimationMixin],
  components: {
    TransitionHeight,
    ExplainResultsHeaderRow,
    ExplainResultsScoreRow,
    ExplainResultsTiebreakersRow
  },
  computed: {
    criteriaDetailTypes: function (): (ScoreCriteriaDetailTypeEnum | string)[] {
      return this.results.reduce((criteriaDetailTypes: string[], result: Result) => {
        const resultScoreCriteria = ExplainUtils.getResultScoreCriteria(result);
        Object.keys(resultScoreCriteria.details).forEach((criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)) => {
          if (!criteriaDetailTypes.includes(criteriaDetailType)) {
            criteriaDetailTypes.push(criteriaDetailType);
          }
        });
        return criteriaDetailTypes;
      }, [...this.defaultCriteriaDetailTypes]);
    }
  },
  data: function () {
    return {
      animationStepDurationsInMillis: [this.initialAnimationDurationInMillis],
      playAnimationOnce: true
    };
  },
  methods: {
    getRowTransitionDelay(rowIndex: number): string {
      if (!!this.initialAnimationDurationInMillis && !this.alreadyPlayedAnimation) {
        const rowAnimationDurationInMillis = (this.initialAnimationDurationInMillis / (this.criteriaDetailTypes.length + 2));
        return `${ (rowAnimationDurationInMillis * rowIndex) }ms`;
      }
    }
  }
};
